const getNavigatorLanguage = () : string =>  {
  return navigator.language.split(/[-_]/)[0]
}

export const languageUtils = {
  getNavigatorLanguage
}
